// automatically generated by the FlatBuffers compiler, do not modify

import { ConnectionStatusMessage } from "../status/connection-status-message";
import { EarthquakeProtectionMessage } from "../status/earthquake-protection-message";
import { EarthquakeStatusMessage } from "../status/earthquake-status-message";
import { GeneralStatusMessage } from "../status/general-status-message";
import { LoadWeigherStatusMessage } from "../status/load-weigher-status-message";
import { ModeStatusMessage } from "../status/mode-status-message";
import { TrafficStatusMessage } from "../status/traffic-status-message";

export enum EscalatorStatusContent {
	NONE = 0,
	EarthquakeProtectionMessage = 1,
	EarthquakeStatusMessage = 2,
	GeneralStatusMessage = 3,
	ConnectionStatusMessage = 4,
	ModeStatusMessage = 5,
	TrafficStatusMessage = 6,
	LoadWeigherStatusMessage = 7,
}

export function unionToEscalatorStatusContent(
	type: EscalatorStatusContent,
	accessor: (
		obj:
			| ConnectionStatusMessage
			| EarthquakeProtectionMessage
			| EarthquakeStatusMessage
			| GeneralStatusMessage
			| LoadWeigherStatusMessage
			| ModeStatusMessage
			| TrafficStatusMessage
	) =>
		| ConnectionStatusMessage
		| EarthquakeProtectionMessage
		| EarthquakeStatusMessage
		| GeneralStatusMessage
		| LoadWeigherStatusMessage
		| ModeStatusMessage
		| TrafficStatusMessage
		| null
):
	| ConnectionStatusMessage
	| EarthquakeProtectionMessage
	| EarthquakeStatusMessage
	| GeneralStatusMessage
	| LoadWeigherStatusMessage
	| ModeStatusMessage
	| TrafficStatusMessage
	| null {
	switch (EscalatorStatusContent[type]) {
		case "NONE":
			return null;
		case "EarthquakeProtectionMessage":
			return accessor(new EarthquakeProtectionMessage())! as EarthquakeProtectionMessage;
		case "EarthquakeStatusMessage":
			return accessor(new EarthquakeStatusMessage())! as EarthquakeStatusMessage;
		case "GeneralStatusMessage":
			return accessor(new GeneralStatusMessage())! as GeneralStatusMessage;
		case "ConnectionStatusMessage":
			return accessor(new ConnectionStatusMessage())! as ConnectionStatusMessage;
		case "ModeStatusMessage":
			return accessor(new ModeStatusMessage())! as ModeStatusMessage;
		case "TrafficStatusMessage":
			return accessor(new TrafficStatusMessage())! as TrafficStatusMessage;
		case "LoadWeigherStatusMessage":
			return accessor(new LoadWeigherStatusMessage())! as LoadWeigherStatusMessage;
		default:
			return null;
	}
}

export function unionListToEscalatorStatusContent(
	type: EscalatorStatusContent,
	accessor: (
		index: number,
		obj:
			| ConnectionStatusMessage
			| EarthquakeProtectionMessage
			| EarthquakeStatusMessage
			| GeneralStatusMessage
			| LoadWeigherStatusMessage
			| ModeStatusMessage
			| TrafficStatusMessage
	) =>
		| ConnectionStatusMessage
		| EarthquakeProtectionMessage
		| EarthquakeStatusMessage
		| GeneralStatusMessage
		| LoadWeigherStatusMessage
		| ModeStatusMessage
		| TrafficStatusMessage
		| null,
	index: number
):
	| ConnectionStatusMessage
	| EarthquakeProtectionMessage
	| EarthquakeStatusMessage
	| GeneralStatusMessage
	| LoadWeigherStatusMessage
	| ModeStatusMessage
	| TrafficStatusMessage
	| null {
	switch (EscalatorStatusContent[type]) {
		case "NONE":
			return null;
		case "EarthquakeProtectionMessage":
			return accessor(index, new EarthquakeProtectionMessage())! as EarthquakeProtectionMessage;
		case "EarthquakeStatusMessage":
			return accessor(index, new EarthquakeStatusMessage())! as EarthquakeStatusMessage;
		case "GeneralStatusMessage":
			return accessor(index, new GeneralStatusMessage())! as GeneralStatusMessage;
		case "ConnectionStatusMessage":
			return accessor(index, new ConnectionStatusMessage())! as ConnectionStatusMessage;
		case "ModeStatusMessage":
			return accessor(index, new ModeStatusMessage())! as ModeStatusMessage;
		case "TrafficStatusMessage":
			return accessor(index, new TrafficStatusMessage())! as TrafficStatusMessage;
		case "LoadWeigherStatusMessage":
			return accessor(index, new LoadWeigherStatusMessage())! as LoadWeigherStatusMessage;
		default:
			return null;
	}
}
